import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import gsap from 'gsap';

interface Props {
	appear?: boolean
	mode?: "in-out" | "out-in" | "default"
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MeasurementsHeightTransition',
  props: {
    appear: { type: Boolean },
    mode: {}
  },
  setup(__props: any) {



function onBeforeEnter(el) {
	gsap.set(el, {
		height: 0,
		overflow: 'hidden',
	});
}

function onEnter(el, done) {
	const sectionHeight = el.scrollHeight;
	gsap.fromTo(
		el,
		{ height: 0 },
		{
			height: sectionHeight,
			duration: 0.3,
			ease: 'power2.in',
			onComplete: done
		}
	);
}

function onAfterEnter(el) {
	gsap.set(el, {
		height: "auto",
		overflow: null,
	});
}

function onBeforeLeave(el) {
	gsap.set(el, {
		overflow: 'hidden',
	});
}

function onLeave(el, done) {
	const sectionHeight = el.scrollHeight;
	gsap.fromTo(
		el,
		{ height: sectionHeight },
		{
			height: 0,
			duration: 0.3,
			ease: 'power2.in',
			onComplete: done
		}
	);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "measurements-height",
    appear: "",
    mode: _ctx.mode,
    onBeforeEnter: onBeforeEnter,
    onEnter: onEnter,
    onAfterEnter: onAfterEnter,
    onBeforeLeave: onBeforeLeave,
    onLeave: onLeave,
    css: false
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["mode"]))
}
}

})